// import { Exercise, SetExercise, User, Workout, SessionSet } from '@api/entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import sessionStorage from 'redux-persist/lib/storage';
// import { ContextEnum } from '@enums/context.enum';
// import { muscleGroups, SelectableExerciseGroup } from '@features/exercise/utils/muscleGroups';
import { stat } from 'fs/promises';
import { ContextEnum } from 'src/_shared/enums/context.enum';
import { Exercise, SessionSet, User, Workout } from 'src/api/entities';
import { muscleGroups, SelectableExerciseGroup } from 'src/features/exercise/utils/muscleGroups';

export interface SelectableExercise {
    label: string;
    value: string;
}

export interface CustomerCreatUpdate {
    email?: string;
    password?: string;
    firstName?: string;
    lastName?: string;
}

export interface CustomerWorkoutSetCreatUpdate {
    exerciseName?: string;
    exerciseGroup?: string;
    exerciseUuid?: string;
    uuid?: string;
    weight?: string;
    reps?: string;
    rest?: string;
}

export interface CustomerWorkoutCreateUpdate {
    name: string;
}

export interface CustomerState {
    customerCreateUpdate: CustomerCreatUpdate;
    context: ContextEnum;
    customers: User[];
    customer: User;
    customerWorkouts: Workout[];
    workout: Workout;
    workoutCreateUpdate: CustomerWorkoutCreateUpdate;
    selectedGroup: string;
    setCreateUpdate: CustomerWorkoutSetCreatUpdate;
    selectableExercises: SelectableExercise[];
    sets: SessionSet[];
    setItem: SessionSet;
}

const initialCustomerCreateUpdate: CustomerCreatUpdate = {
    email: '',
    password: '',
};

const initialState: CustomerState = {
    customerCreateUpdate: initialCustomerCreateUpdate,
    customers: [],
    context: ContextEnum.CREATE,
    customer: {},
    customerWorkouts: [],
    selectableExercises: [],
    workoutCreateUpdate: {
        name: '',
        // sets: [],
    },
    workout: {},
    setCreateUpdate: {
        exerciseGroup: '',
        exerciseName: '',
        exerciseUuid: '',
        uuid: '',
        reps: '',
        weight: '',
        rest: '',
    },
    selectedGroup: muscleGroups[0].value,
    sets: [],
    setItem: {},
};

export const customerPersistedConfig = {
    key: 'customer',
    storage: sessionStorage,
    whitelist: [
        'customerCreateUpdate',
        'workoutCreateUpdate',
        'customers',
        'context',
        'customer',
        'customerWorkouts',
        'workout',
        'selectableExercises',
        'sets',
        'setItem',
        'setCreateUpdate',
    ],
};

export const customerSlice = createSlice({
    name: 'customer',
    initialState: initialState,
    reducers: {
        setCustomerSetFormValue(state, action: PayloadAction<{ key: keyof CustomerCreatUpdate; value: string }>) {
            state.customerCreateUpdate[action.payload.key] = action.payload.value;
        },
        resetCustomerSetFormValue(state) {
            state.customerCreateUpdate = initialState.customerCreateUpdate;},
        setCustomerWorkoutFormValue(state, action: PayloadAction<{ key: keyof CustomerWorkoutCreateUpdate; value: string }>) {
            state.workoutCreateUpdate[action.payload.key] = action.payload.value;
        },
        setCustomerWorkoutSetFormValue(state, action: PayloadAction<{ key: keyof CustomerWorkoutSetCreatUpdate; value: string }>) {
            state.setCreateUpdate[action.payload.key] = action.payload.value;
        },
        resetCustomerWorkoutSetFormValue(state) {
            state.setCreateUpdate = initialState.setCreateUpdate;
        },
        resetCustomerWorkoutFormValue(state) {
            state.workoutCreateUpdate = initialState.workoutCreateUpdate;
        },
        setCustomerItems(state, action: PayloadAction<{ value: User[] }>) {
            state.customers = action.payload.value;
        },
        setWorkoutItem(state, action: PayloadAction<{ response: Workout }>) {
            state.workout = action.payload.response;
            console.log(state.workout)
            console.log(action.payload.response )
        },
        resetWorkoutItem(state) {
            state.workout = {};
        },
        setCustomerItem(state, action: PayloadAction<{ value: User }>) {
            state.customer = action.payload.value;
        },
        resetCustomerCreateUpdate(state) {
            state.customerCreateUpdate = initialState.customerCreateUpdate;
        },
        setCustomerWorkoutItems(state, action: PayloadAction<{ value: Workout[] }>) {
            state.customerWorkouts = action.payload.value;
        },
        setContext(state, action: PayloadAction<{ value: ContextEnum }>) {
            state.context = action.payload.value;
        },
        setSelectedGroup(state, action: PayloadAction<{ group: SelectableExerciseGroup }>) {
            state.setCreateUpdate.exerciseGroup = action.payload.group.value;
        },
        setSelectableExercises(state, action: PayloadAction<{ value: Exercise[] }>) {
            state.selectableExercises = [];
            action.payload.value.forEach(currentExercise => {
                const selectable: SelectableExercise = {
                    label: currentExercise.name!,
                    value: currentExercise.uuid!,
                };
                state.selectableExercises.push(selectable);
            });
            state.selectableExercises = state.selectableExercises.sort((a, b) => a.label.localeCompare(b.label));
        },
        setSelectedExercise(state, action: PayloadAction<{ value: SelectableExercise }>) {
            state.setCreateUpdate.exerciseName = action.payload.value.label;
            state.setCreateUpdate.exerciseUuid = action.payload.value.value;
        },
        setWorkoutSetItems(state, action: PayloadAction<{ sets: SessionSet[] }>) {
            state.sets = action.payload.sets;
        },
        resetWorkoutSetItems(state) {
            state.sets = [];
        },
        setSetItem(state, action: PayloadAction<{ value: SessionSet }>) {
            state.setItem = action.payload.value;
        },
        resetSetItem(state) {
            state.setItem = initialState.setItem
        },
    },
});

export const {
    setCustomerSetFormValue,
    resetCustomerSetFormValue,
    setCustomerItems,
    setCustomerItem,
    resetCustomerCreateUpdate,
    setContext,
    setCustomerWorkoutItems,
    setSelectableExercises,
    setCustomerWorkoutFormValue,
    setSelectedExercise,
    setWorkoutItem,
    resetWorkoutItem,
    setSelectedGroup,
    resetCustomerWorkoutFormValue,
    setCustomerWorkoutSetFormValue,
    setWorkoutSetItems,
    resetWorkoutSetItems,
    resetCustomerWorkoutSetFormValue,
    setSetItem,
    resetSetItem
} = customerSlice.actions;

export const customerReducer = customerSlice.reducer;
